var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.schedule.type,
      callback: function ($$v) {
        _vm.$set(_vm.form.schedule, "type", $$v);
      },
      expression: "form.schedule.type"
    }
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-radio', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })];
  })], 2), _c('v-expand-transition', [_c('v-sheet', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isTypeOnTime,
      expression: "isTypeOnTime"
    }]
  }, [_c('v-row', {
    staticClass: "mt-8 mx-n4 mb-n4"
  }, [_c('v-col', {
    staticClass: "pa-4"
  }, [_c('v-date-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.schedule.date,
      callback: function ($$v) {
        _vm.$set(_vm.form.schedule, "date", $$v);
      },
      expression: "form.schedule.date"
    }
  }, 'v-date-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-4"
  }, [_c('schedule-hour', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.schedule,
      callback: function ($$v) {
        _vm.$set(_vm.form, "schedule", $$v);
      },
      expression: "form.schedule"
    }
  }, 'schedule-hour', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-4"
  }, [_c('schedule-minute', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.schedule,
      callback: function ($$v) {
        _vm.$set(_vm.form, "schedule", $$v);
      },
      expression: "form.schedule"
    }
  }, 'schedule-minute', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "font-size-14 grey--text text--lighten-2"
  }, [_vm._v(" ※ 예약 일정 설정시 해당 시간 전에는 참여가 불가능합니다. "), _c('br'), _vm._v(" 예약 시간 30분 전에 알림톡으로 모든 참석자에게 참석알림이 발송됩니다. ")])])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }